import React from "react";
import MissionHero from "./mission/MissionHero";
import KeyObjectives from "./mission/KeyObjectives";
import DistinctiveValue from "./mission/DistinctiveValue";

const Mission = () => {
  return (
    <div className="relative overflow-hidden">
      <MissionHero />
      <KeyObjectives />
      <DistinctiveValue />
    </div>
  );
};

export default Mission;